import styled from "styled-components";

export const Wrap = styled.div`
  @media (max-width: 991px) {
    margin-top: 50px;
  }
`;
export const Block = styled.div`
  position: relative;
  z-index: 2;
  padding: 26px 19px;
  padding-right: 14px;
  height: 250px;
  background-color: var(--bg-elevate);
  border-radius: 7px;
  margin-bottom: 29px;
  font-size: 14px;
  font-weight: 600;
  @media (max-width: 991px) {
    margin-bottom: 20px;
  }
  @media (max-width: 575px) {
    text-align: left;
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }
`;
export const BlobBlock = styled(Block)`
  background: ${({ theme }) => {
    if (theme.__name__ === "light") {
      return "url(/blobs/angle.svg) no-repeat left top";
    } else if (theme.__name__ === "dark") {
      return "url(/blobs/angle_dark.svg) no-repeat left top";
    }
  }};
  background-size: 100% auto;
  background-color: var(--bg-elevate);
  @media (max-width: 1199px) {
    background-size: 118% auto;
  }
  @media (max-width: 991px) {
    background-size: 50% auto;
    height: auto;
  }
  @media (max-width: 765px) {
    background-size: 63% auto;
    height: auto;
  }
  @media (max-width: 575px) {
    background-image: none;
  }
`;
export const Title = styled.h3`
  color: var(--font-color-emp);
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  margin-top: -2px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  @media (max-width: 575px) {
    &&& {
      text-align: left;
      align-self: flex-start;
    }
  }
`;
export const ListSect = styled.div`
  position: relative;
  @media (max-width: 991px) {
    h3 {
      text-align: center;
    }
  }
`;
export const ListBlock = styled(Block)`
  position: relative;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
`;
export const ListDelim = styled.div`
  width: 100%;
  height: 2px;
  background-color: white;
  margin: 13px 0;
`;
export const MapContainer = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
  margin-bottom: 29px;
`;
export const AsideIcon = styled.i`
  position: absolute;
  right: 18px;
  top: 18px;
`;
